const overlay = document.createElement('div');
overlay.className = 'ws-lightbox';
overlay.innerHTML = `
  <div class="ws-lightbox__backdrop"></div>
  <div class="ws-lightbox__box">
    <button class="ws-lightbox__close" aria-label="Schließen">&#x2715;</button>
    <div class="ws-lightbox__inner">
      <button class="ws-lightbox__prev" aria-label="Zurück"><span>&#8249;</span></button>
      <button class="ws-lightbox__next" aria-label="Weiter"><span>&#8250;</span></button>
      <img class="ws-lightbox__img" src="" alt="" />
    </div>
    <div class="ws-lightbox__caption"><span></span></div>
  </div>
`;
document.body.appendChild(overlay);

const img = overlay.querySelector<HTMLImageElement>('.ws-lightbox__img')!;
const captionSpan = overlay.querySelector<HTMLElement>('.ws-lightbox__caption span')!;
const btnClose = overlay.querySelector<HTMLButtonElement>('.ws-lightbox__close')!;
const btnPrev = overlay.querySelector<HTMLButtonElement>('.ws-lightbox__prev')!;
const btnNext = overlay.querySelector<HTMLButtonElement>('.ws-lightbox__next')!;

let images: string[] = [];
let current = 0;
let title = '';

function show(index: number): void {
    const animate = index !== current;
    const direction = index > current ? 1 : -1;
    current = (index + images.length) % images.length;
    const multi = images.length > 1;
    btnPrev.style.display = multi ? '' : 'none';
    btnNext.style.display = multi ? '' : 'none';

    if (animate) {
        // Slide + fade out in the direction of travel
        img.style.transition = 'opacity 0.18s ease, transform 0.18s ease';
        img.style.opacity = '0';
        img.style.transform = `translateX(${direction * -60}px)`;

        setTimeout(() => {
            img.src = images[current];
            img.alt = title;
            captionSpan.textContent = title;
            // Place new image on the opposite side with no transition
            img.style.transition = 'none';
            img.style.transform = `translateX(${direction * 60}px)`;
            // Force reflow so the position change registers before animating in
            void img.offsetHeight;
            img.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
            img.style.opacity = '1';
            img.style.transform = 'translateX(0)';
        }, 200);
    } else {
        img.src = images[current];
        img.alt = title;
        captionSpan.textContent = title;
    }
}

function open(srcs: string[], titleText: string, startIndex = 0, large = false): void {
    images = srcs;
    title = titleText;
    overlay.classList.add('ws-lightbox--open');
    overlay.classList.toggle('ws-lightbox--large', large);
    document.body.style.overflow = 'hidden';
    show(startIndex);
}

function close(): void {
    overlay.classList.remove('ws-lightbox--open', 'ws-lightbox--large');
    document.body.style.overflow = '';
    img.src = '';
}

btnClose.addEventListener('click', close);
btnPrev.addEventListener('click', () => show(current - 1));
btnNext.addEventListener('click', () => show(current + 1));
overlay.querySelector('.ws-lightbox__backdrop')!.addEventListener('click', close);

document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('ws-lightbox--open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
});

// ── Textpic gallery (Sanierung-style: figures grouped by data-textpic-gallery) ──
const textpicGroups = new Map<string, { el: HTMLElement; img: HTMLImageElement }[]>();
document.querySelectorAll<HTMLElement>('.js-textpic-figure').forEach((fig) => {
    const groupId = fig.dataset.textpicGallery ?? '';
    const img = fig.querySelector<HTMLImageElement>('img');
    if (!groupId || !img) return;
    if (!textpicGroups.has(groupId)) textpicGroups.set(groupId, []);
    textpicGroups.get(groupId)!.push({ el: fig, img });
});

textpicGroups.forEach((figures) => {
    const srcs = figures.map((f) => f.el.dataset.fullSrc || f.img.src).filter(Boolean);
    figures.forEach(({ el }, idx) => {
        el.addEventListener('click', () => open(srcs, '', idx, true));
    });
});

// ── Project showcase galleries ───────────────────────────────────────────────
document.querySelectorAll<HTMLElement>('.js-showcase-gallery').forEach((gallery) => {
    const title = gallery.dataset.title ?? '';
    const thumbs = gallery.querySelectorAll<HTMLElement>('.project-showcase__thumb');
    const mainImgEl = gallery.querySelector<HTMLElement>('.project-showcase__main-img');
    const srcs = Array.from(thumbs)
        .map((t) => t.dataset.fullSrc || t.querySelector<HTMLImageElement>('img')?.src || '')
        .filter(Boolean);

    // Click on main image → open lightbox at current thumb index
    if (mainImgEl) {
        mainImgEl.addEventListener('click', () => {
            const active = Array.from(thumbs).findIndex((t) =>
                t.classList.contains('project-showcase__thumb--active'));
            open(srcs, title, Math.max(0, active), true);
        });
    }

    // Click on thumbnail → open lightbox at that index
    thumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', () => open(srcs, title, idx, true));
    });
});

// ── Worksample thumbnails ─────────────────────────────────────────────────────
document.querySelectorAll<HTMLElement>('.js-worksample-thumb').forEach((thumb) => {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', () => {
        const entryTitle = thumb.dataset.title ?? '';
        const galleryData = thumb.querySelector('.worksample-entry__gallery-data');
        let srcs: string[] = [];

        if (galleryData) {
            srcs = Array.from(galleryData.querySelectorAll<HTMLImageElement>('img'))
                .map((i) => i.src)
                .filter(Boolean);
        }
        if (srcs.length === 0) {
            const featureImg = thumb.querySelector<HTMLImageElement>('img');
            if (featureImg) srcs = [featureImg.src];
        }
        if (srcs.length > 0) open(srcs, entryTitle);
    });
});
